import { Controller } from "@hotwired/stimulus"

// The filter drawer sits inside the frame that applying a filter replaces. When it is replaced while open, Bootstrap never gets to
// finish closing it, which would leave the dimmed backdrop over the page and the page unable to scroll. Clean that up.
export default class extends Controller {
  disconnect() {
    document.querySelectorAll(".offcanvas-backdrop").forEach((backdrop) => backdrop.remove())
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
  }
}
